import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorldRankingBootstrapComponent } from './components/world-ranking-bootstrap/world-ranking-bootstrap.component';

const routes: Routes = [
  {
    path: '',
    component: WorldRankingBootstrapComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorldRankingRoutingModule {}
